import React from 'react'
import {useTranslation} from 'react-i18next'
import {Typography} from 'antd'
import classNames from 'classnames'
import {useScreenType, useLocalStorageBoolean} from '@/hooks'
import {IS_SIDER_COLLAPSED_KEY} from '@/constants'
import {DigitalReceiptsButtons} from '../'
import NewWayImg from '~/assets/img/digital-receipts/new_way_v3.svg'

import styles from './styles.scss'

export const NewWayToEngage = () => {
    const {t} = useTranslation()
    const {isMobile, isTablet, isLaptop, isDesktop} = useScreenType()
    const isCollapsed = useLocalStorageBoolean(IS_SIDER_COLLAPSED_KEY)
    const titleLevel = isDesktop ? 2 : 3

    const containerClass = classNames(styles.container, {
        [styles.mobileLayout]: isMobile,
        [styles.tabletLayout]: isTablet && !isCollapsed,
        [styles.desktopLayout]: isLaptop || isDesktop || (isTablet && isCollapsed)
    })

    return (
        <div className={containerClass}>
            <div className={styles.badge}>
                <img
                    src='/img/logo/dna-payments-logo-dark.svg'
                    alt='DNA Payments'
                    className={styles.logo}
                />

                <img
                    src='/img/digital-receipts/taployo_logo.svg'
                    alt='Taployo'
                    className={styles.logo}
                />
            </div>
            <div className={styles.img}>
                <img src={NewWayImg} alt={t('NewWayToEngage.alt')} />
            </div>

            <div className={styles.content}>
                <Typography.Title level={titleLevel} className={styles.title}>
                    {t('NewWayToEngage.title')}
                </Typography.Title>
                <Typography.Paragraph className={styles.text}>
                    {t('NewWayToEngage.description')}
                </Typography.Paragraph>

                <DigitalReceiptsButtons />
            </div>
        </div>
    )
}
